<template>
  <div @click="closeSelect">
    <div class="row search-row">
      <!-- SEARCH ROW -->
      <div class="col-12 col-md-4">
        <div class="student-search position-relative">
          <div
            class="position-absolute icon-search brand_inverse index-9"
          ></div>
          <input
            type="text"
            v-model="form.student_info"
            class="form-control
          position-relative"
            placeholder="Find student by name or Student code"
            @input="$emit('apply-sort', form)"
          />
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="class-search">
          <select
            class="form-control"
            v-model="form.selected_class"
            @change="$emit('apply-sort', form)"
          >
            <option value selected disabled>Select Class</option>
            <option value="" selected>All</option>
            <option
              v-for="(value, index) in class_options"
              :value="value.id"
              :key="index"
            >
              {{ value.name }}
            </option>
          </select>

          <!-- <CustomSelect
            select_label="Class"
            placeholder="Select class"
            :options="class_options"
            :trigger_close="close_select"
            @selectionDone="updateClassList($event)"
          /> -->
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="licence-search">
          <select
            class="form-control"
            v-model="form.selected_license"
            @change="$emit('apply-sort', form)"
          >
            <option value="" disabled selected>Select License</option>
            <option value="all">All</option>
            <option value="disable">Disabled</option>
            <option value="basic">Basic</option>
            <option value="premium">Premium</option>
          </select>

          <!-- <CustomSelect
            select_label="License"
            placeholder="Select License"
            :options="license_options"
            :trigger_close="close_select"
            @selectionDone="updateClassLicense($event)"
          /> -->
        </div>
      </div>
      <!-- SEARCH ROW -->
    </div>
  </div>
</template>

<script>
// import CustomSelect from "@/components/globalComps/CustomSelect";
import { mapActions } from "vuex";

export default {
  name: "StudentSearchRow",

  components: {
    // CustomSelect,
  },

  data() {
    return {
      class_options: [],
      license_options: [{ id: 1, name: "Basic", selected: false }],
      close_select: true,
      form: {
        student_info: "",
        selected_class: "",
        selected_license: "",
      },
    };
  },

  mounted() {
    this.fetchClasses();
  },

  methods: {
    ...mapActions(["getSchoolClasses"]),

    fetchClasses() {
      this.getSchoolClasses()
        .then((response) => {
          // console.log(response);
          response.data.map((year) => {
            year.classes.map((arm) => {
              let class_arm = {};
              class_arm.id = arm.id;
              class_arm.name = `${arm.class_name}`;
              class_arm.selected = false;
              this.class_options.push(class_arm);
            });
          });
        })
        .catch((err) => console.log(err));
    },

    closeSelect($event) {
      if ($event.target.classList.contains("ignore")) return false;
      else this.close_select = !this.close_select;
    },

    updateClassList($event) {
      let { selection } = $event;
      if (selection.length > 0)
        this.form.selected_class = Number(selection[0].id);
      else this.form.selected_class = "";
    },

    updateClassLicense($event) {
      let { selection } = $event;
      if (selection.length > 0)
        this.form.selected_license = Number(selection[0].id);
      else this.form.selected_license = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.search-row {
  margin-bottom: 30px;
  animation: panel-slide-down 0.25s ease-in-out forwards;
  transition: all 0.3s ease-in-out;

  @include breakpoint_max(md) {
    margin-bottom: 45px;
    position: relative;
    top: 30px;
  }

  .student-search {
    @include breakpoint_max(md) {
      margin-bottom: 15px;
    }
    .icon-search {
      font-size: 22px;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    input {
      padding-left: 45px !important;
    }
  }

  .class-search {
    .text-holder {
      font-size: 14px;
      line-height: 19px;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
